import Layout from './components/Layout'
import './App.css'



const App = () => {
  return (
    <Layout />
  )
}

export default App